import { Filter } from "types/types"

type FilterValue = Filter["value"]

interface UseSelectConfig {
  list: Filter[]
  selectedList: FilterValue[]
  onChangeSelectedList: (newSelectedList: FilterValue[]) => void
}

const useSelect = ({ list, selectedList, onChangeSelectedList }: UseSelectConfig) => {
  const select = (value: FilterValue, iSelected: boolean) => {
    if (iSelected) onChangeSelectedList(selectedList.filter((filterValue) => filterValue !== value))
    else onChangeSelectedList([...selectedList, value])
  }

  const selectAll = () => onChangeSelectedList(list.map((item) => item.value))
  const deselectAll = () => onChangeSelectedList([])

  const isSelected = (value: FilterValue) =>
    !!selectedList.find((filterValue) => filterValue === value)

  const canSelectAll = selectedList.length === 0
  const isSomethingSelected = selectedList.length > 0 && selectedList.length !== list.length
  const amountOfSelectedItems = list.length + selectedList.length - list.length

  return {
    select,
    selectAll,
    deselectAll,

    isSelected,
    isSomethingSelected,
    canSelectAll,

    amountOfSelectedItems,
  }
}

export default useSelect
